import { render, staticRenderFns } from "./MFA.vue?vue&type=template&id=03c1342e&scoped=true"
import script from "./MFA.vue?vue&type=script&lang=ts"
export * from "./MFA.vue?vue&type=script&lang=ts"
import style0 from "./MFA.vue?vue&type=style&index=0&id=03c1342e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c1342e",
  null
  
)

export default component.exports